import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Col } from "react-bootstrap";
import { ATTACHMENT_TYPES } from "MODULES/MistakeShipments/constants";
import DashedSeparator from "MODULES/shared/components/DashedSeparator";
import {
  Attachments,
  AuditFields,
  ClipboardCopy,
  Notes,
  RecordPager
} from "MODULES/shared/components";
import { CONSIGNMENT_REFERENCE } from "MODULES/Receiving/constants";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import { loadRecord } from "MODULES/shared/decorators";
import { DetailsTable } from "MODULES/Consignments/Detail/DetailsTable";
import Inventories from "MODULES/Consignments/Detail/Inventories";
import { ConsignmentDetailsTable } from "MODULES/Consignments/Detail/ConsignmentDetailTable";
import {
  consignmentInventoriesPagination,
  consignmentLineItemsPagination
} from "MODULES/Consignments/pagination";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import ImportConsignments from "MODULES/Consignments/Detail/ImportConsignments/ImportConsignments";
import LineItemsTable from "MODULES/Consignments/Detail/LineItemsTable";
import { show } from "../actions";

function Detail({ consignment, inventorySearch, lineItemSearch }) {
  const parsedConsignment = consignment.toJS();

  return (
    <Col>
      <div className="page-header page-header-bar">
        <h1>
          <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
            <ActionDropDown
              menuClass="dropdown-menu-right"
              style={{ cursor: "pointer" }}
            >
              <ImportConsignments consignment={consignment.toJS()} />
            </ActionDropDown>
          </div>
          <div className="with-padding">
            <RecordPager baseUrl="/consignments" record={consignment} />
            <span className="header-content">
              {consignment.get(CONSIGNMENT_REFERENCE)}
            </span>
            <ClipboardCopy
              name={consignment.get(CONSIGNMENT_REFERENCE)}
              type="Consignment"
            />
          </div>
        </h1>
      </div>
      <Col md={3}>
        <div className="panel panel-default">
          <div className="panel-body">
            <DetailsTable consignment={parsedConsignment} />
            <ConsignmentDetailsTable consignment={parsedConsignment} />
            <DashedSeparator />
            <AuditFields record={consignment} multiLine />
          </div>
        </div>
      </Col>
      <Col md={9}>
        <LineItemsTable consignment={consignment} search={lineItemSearch} />
        <Inventories consignment={consignment} search={inventorySearch} />
        <Notes
          resource={consignment}
          resourceType={resourceTypes.consignment}
          resourceKey="consignment"
        />
        <Attachments
          multiple
          resource={consignment}
          resourceType={resourceTypes.consignment}
          resourceKey="consignment"
          attachmentTypes={ATTACHMENT_TYPES}
        />
      </Col>
    </Col>
  );
}

Detail.propTypes = {
  consignment: T.instanceOf(Map)
};

export default connect(
  state => ({
    consignment: state.consignmentDetail.get("consignment")
  }),
  dispatch => ({
    inventorySearch: val =>
      dispatch(consignmentInventoriesPagination.setFilter("filter", val)),
    lineItemSearch: val =>
      dispatch(consignmentLineItemsPagination.setFilter("filter", val))
  })
)(
  loadRecord({
    reducer: "consignmentDetail",
    name: "consignment",
    action: show
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/Consignments/Detail/Detail.jsx